module.exports = __webpack_public_path__ + "static/img/erweima_weibo.d34e8c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erweima_weibo.png
// module id = eVkx
// module chunks = 1